import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getCompanyById, patchContactoEmpresa } from '../services/api';
import { toast } from 'react-toastify';
import '../styles/styles.css';
import { formatPhone } from '../utils/phone';

const EditarContacto = () => {
    const { empresaId, contactoId } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        telefono: '',
        cargo: ''
    });
    const [loading, setLoading] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchContacto = async () => {
            try {
                const { data } = await getCompanyById(empresaId);
                const contacto = data.contactos?.find(
                    (c) => String(c.id_contacto) === String(contactoId)
                );
                if (!contacto) {
                    setError('No se encontró el contacto.');
                    return;
                }
                setFormData({
                    nombre: contacto.nombre || '',
                    email: contacto.email || '',
                    telefono: contacto.telefono || '',
                    cargo: contacto.cargo || ''
                });
            } catch (err) {
                console.error('Error al obtener contacto:', err);
                setError('No se pudo cargar el contacto.');
            } finally {
                setCargando(false);
            }
        };
        fetchContacto();
    }, [empresaId, contactoId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'telefono') {
            setFormData((prev) => ({ ...prev, [name]: formatPhone(value) }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await patchContactoEmpresa(empresaId, formData, contactoId);
            toast.success('Contacto actualizado correctamente');
            navigate(`/empresas/${empresaId}`);
        } catch (err) {
            console.error('Error al actualizar contacto:', err);
            toast.error('No se pudo actualizar el contacto');
        } finally {
            setLoading(false);
        }
    };

    if (cargando) return <p>Cargando contacto...</p>;
    if (error) return <p className="required-text">{error}</p>;

    return (
        <div>
            <div className="content-wrapper">
                <h1>Editar Contacto</h1>
                <div className="container">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleChange}
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label>Teléfono</label>
                            <div className="phone-input-group">
                                <span className="phone-prefix">+56</span>
                                <input
                                    type="tel"
                                    name="telefono"
                                    value={formData.telefono}
                                    onChange={handleChange}
                                    maxLength={9}
                                    size={16}
                                    placeholder="912345678"
                                    className="phone-input-field"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Cargo</label>
                            <input
                                type="text"
                                name="cargo"
                                value={formData.cargo}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <button type="submit" className="btn btn-create" disabled={loading}>
                                {loading ? 'Guardando...' : 'Guardar'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditarContacto;
